/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { SecurityFunction } from '../model/securityFunction';
import { SecurityFunctionCreateRequest } from '../model/securityFunctionCreateRequest';
import { SecurityFunctionKeys } from '../model/securityFunctionKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SecurityFunctionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createSecurityFunction
     * Creates a new security function.
     * @param securityFunctionCreateRequest the information needed to create a security function
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityFunctionCreateSecurityFunction(securityFunctionCreateRequest: SecurityFunctionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<SecurityFunction>;
    public securityFunctionCreateSecurityFunction(securityFunctionCreateRequest: SecurityFunctionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityFunction>>;
    public securityFunctionCreateSecurityFunction(securityFunctionCreateRequest: SecurityFunctionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityFunction>>;
    public securityFunctionCreateSecurityFunction(securityFunctionCreateRequest: SecurityFunctionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityFunctionCreateRequest === null || securityFunctionCreateRequest === undefined) {
            throw new Error('Required parameter securityFunctionCreateRequest was null or undefined when calling securityFunctionCreateSecurityFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SecurityFunction>(`${this.configuration.basePath}/securityFunctions`,
            securityFunctionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteSecurityFunction
     * Deletes an existing security function by security function name.
     * @param securityFunctionName the security function name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityFunctionDeleteSecurityFunction(securityFunctionName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityFunction>;
    public securityFunctionDeleteSecurityFunction(securityFunctionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityFunction>>;
    public securityFunctionDeleteSecurityFunction(securityFunctionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityFunction>>;
    public securityFunctionDeleteSecurityFunction(securityFunctionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityFunctionName === null || securityFunctionName === undefined) {
            throw new Error('Required parameter securityFunctionName was null or undefined when calling securityFunctionDeleteSecurityFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<SecurityFunction>(`${this.configuration.basePath}/securityFunctions/${encodeURIComponent(String(securityFunctionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityFunction
     * Retrieves an existing security function by security function name.
     * @param securityFunctionName the security function name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityFunctionGetSecurityFunction(securityFunctionName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityFunction>;
    public securityFunctionGetSecurityFunction(securityFunctionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityFunction>>;
    public securityFunctionGetSecurityFunction(securityFunctionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityFunction>>;
    public securityFunctionGetSecurityFunction(securityFunctionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityFunctionName === null || securityFunctionName === undefined) {
            throw new Error('Required parameter securityFunctionName was null or undefined when calling securityFunctionGetSecurityFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityFunction>(`${this.configuration.basePath}/securityFunctions/${encodeURIComponent(String(securityFunctionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityFunctions
     * Gets a list of security function keys for all security functions defined in the system. The result list is sorted by security function name in ascending order.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityFunctionGetSecurityFunctions(observe?: 'body', reportProgress?: boolean): Observable<SecurityFunctionKeys>;
    public securityFunctionGetSecurityFunctions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityFunctionKeys>>;
    public securityFunctionGetSecurityFunctions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityFunctionKeys>>;
    public securityFunctionGetSecurityFunctions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityFunctionKeys>(`${this.configuration.basePath}/securityFunctions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
